import React from "react";
import PropTypes from "prop-types";
import { default as ReactSelect } from "react-select";

const MySelect = ({ allowSelectAll, allOption, options, onChange, ...props }) => {
  // Add null checks for options
  const safeOptions = options || [];
  const safeAllOption = allOption || { label: "Select all", value: "*" };

  const handleChange = (selected, event) => {
    if (selected !== null && selected.length > 0) {
      if (selected[selected.length - 1].value === safeAllOption.value) {
        return onChange([safeAllOption, ...safeOptions]);
      }
      let result = [];
      if (selected.length === safeOptions.length) {
        if (selected.includes(safeAllOption)) {
          result = selected.filter(option => option.value !== safeAllOption.value);
        } else if (event.action === "select-option") {
          result = [safeAllOption, ...safeOptions];
        }
        return onChange(result);
      }
    }
    return onChange(selected);
  };

  return (
    <ReactSelect
      {...props}
      options={allowSelectAll ? [safeAllOption, ...safeOptions] : safeOptions}
      onChange={allowSelectAll ? handleChange : onChange}
    />
  );
};

MySelect.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  allowSelectAll: PropTypes.bool,
  allOption: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string
  })
};

MySelect.defaultProps = {
  allOption: {
    label: "Select all",
    value: "*"
  }
};

export default MySelect;
